import AI21Icon from '@/assets/model-icons/AI21.svg';
import AnthropicClaudeIcon from '@/assets/model-icons/anthropic-claude.svg';
import AWSIcon from '@/assets/model-icons/aws.svg';
import CohereCommandIcon from '@/assets/model-icons/cohere-command.svg';
import MetaLlamaIcon from '@/assets/model-icons/meta-llama2.svg';
import MistralIcon from '@/assets/model-icons/mistral.svg';
import DeepSeekIcon from '@/assets/model-icons/deepseek.svg';
import OpenAIIcon from '@/assets/model-icons/openai.svg';
import GeminiIcon from '@/assets/connector-icons/google-gemini.png';
import SonarIcon from '@/assets/model-icons/sonar.svg';
import GemmaIcon from '@/assets/model-icons/gemma.svg';
import GoogleIcon from '@/assets/model-icons/google.svg';
import NvidiaIcon from '@/assets/connector-icons/nvidia.png';
import QwenIcon from '@/assets/model-icons/qwen.svg';
import MicrosoftIcon from '@/assets/model-icons/microsoft.svg';
import IbmIcon from '@/assets/model-icons/ibm.svg';
import DatabricksIcon from '@/assets/model-icons/databricks.svg';
import WriterIcon from '@/assets/model-icons/writer.svg';
import TwelvelabsIcon from '@/assets/model-icons/twelvelabs.svg';
import ZaiIcon from '@/assets/model-icons/zai.svg';
import MinimaxIcon from '@/assets/model-icons/minimax.svg';
import MoonshotIcon from '@/assets/model-icons/moonshot.svg';
import GrokIcon from '@/assets/model-icons/grok.svg';
import InceptionIcon from '@/assets/model-icons/inceptionai.png';
import PerplexityIcon from '@/assets/connector-icons/perplexity.png';

export const ModelIconMap: Map<string, string> = new Map([
  ['ai21', AI21Icon],
  ['j2', AI21Icon],
  ['jamba', AI21Icon],
  ['anthropic', AnthropicClaudeIcon],
  ['claude', AnthropicClaudeIcon],
  ['amazon', AWSIcon],
  ['nova', AWSIcon],
  ['titan', AWSIcon],
  ['cohere', CohereCommandIcon],
  ['command', CohereCommandIcon],
  ['deepseek', DeepSeekIcon],
  ['gemini', GeminiIcon],
  ['learnlm', GeminiIcon],
  ['lyria', GeminiIcon],
  ['gemma', GemmaIcon],
  ['codegemma', GemmaIcon],
  ['gpt', OpenAIIcon],
  ['llama', MetaLlamaIcon],
  ['mistral', MistralIcon],
  ['codestral', MistralIcon],
  ['mixtral', MistralIcon],
  ['ministral', MistralIcon],
  ['pixtral', MistralIcon],
  ['devstral', MistralIcon],
  ['magistral', MistralIcon],
  ['voxtral', MistralIcon],
  ['o1', OpenAIIcon],
  ['o3', OpenAIIcon],
  ['o4', OpenAIIcon],
  ['o5', OpenAIIcon],
  ['sonar', SonarIcon],
  ['pplx', PerplexityIcon],
  ['bert', GoogleIcon],
  ['speechtotext', NvidiaIcon],
  ['slu', NvidiaIcon],
  ['stt', NvidiaIcon],
  ['biomegatron', NvidiaIcon],
  ['gatortron', NvidiaIcon],
  ['starcoder', NvidiaIcon],
  ['mixtral', MistralIcon],
  ['nmt', NvidiaIcon],
  ['nvidia', NvidiaIcon],
  ['nemotron', NvidiaIcon],
  ['qwen', QwenIcon],
  ['microsoft', MicrosoftIcon],
  ['phi', MicrosoftIcon],
  ['mai-ds', MicrosoftIcon],
  ['ibm', IbmIcon],
  ['databricks', DatabricksIcon],
  ['writer', WriterIcon],
  ['palmyra', WriterIcon],
  ['twelvelabs', TwelvelabsIcon],
  ['pegasus', TwelvelabsIcon],
  ['zai', ZaiIcon],
  ['glm', ZaiIcon],
  ['minimax', MinimaxIcon],
  ['moonshot', MoonshotIcon],
  ['kimi', MoonshotIcon],
  ['grok', GrokIcon],
  ['jais', InceptionIcon],
]);

export const getModelIcon = (modelId: string): string => {
  const vendorRegex = new RegExp(Array.from(ModelIconMap.keys()).join('|'));

  const vendorMatch = String(modelId).toLowerCase().match(vendorRegex);

  if (!vendorMatch?.[0]) {
    // console.warn('unknown modelId -> iconId', { modelId });
    return '';
  }

  const vendorId = vendorMatch?.[0];

  return ModelIconMap.get(vendorId) || '';
};
